import { useState, useEffect } from 'react';
import { PaymentAPI } from '../services/api';

const usePaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await PaymentAPI.getPaymentGateways();
        const methods = response.payment_gateways || [];
        setPaymentMethods(methods);
        
        // Задаване на метод за плащане по подразбиране, ако е наличен
        if (methods.length > 0) {
          setSelectedPayment(methods[0].id);
        }
      } catch (err) {
        console.error('Грешка при извличане на методи за плащане:', err);
        setError('Неуспешно зареждане на методи за плащане. Моля, опитайте отново по-късно.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchPaymentMethods();
  }, []);

  const handlePaymentChange = (e) => {
    setSelectedPayment(e.target.value);
  };

  return {
    paymentMethods,
    selectedPayment,
    setSelectedPayment,
    loading,
    error,
    handlePaymentChange
  };
};

export default usePaymentMethods; 